import { generateRank } from "~/plugins/grapesjs/helper";
import { birthdayIcon } from '~/assets/icons/js/birthdayIcon';
import tippy from 'tippy.js';
import Vue from 'vue';
import AppEditor from '~/components/AppEditor';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const MD = editor.Modal;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;


    const FORMAT_1 = "select";
    const FORMAT_2 = "input";
    const RANK_MIN = "2000-01-12";
    const RANK_MAX = "2000-12-31";

    var model = MODEL.extend({

        defaults: {
            ...MODEL.prototype.defaults,
            tagName: 'div',
            draggable: 'form, form *',
            droppable: ".invalid-feedback",
            attributes: {
                ...MODEL.prototype.defaults.attributes,
                name: "birthday",
                "data-slg-type": "C-BIRTHDAY",
                "data-slg-custom-menu": true,
                "data-slg-format": "input",
                "data-slg-rank-min": RANK_MIN,
                "data-slg-rank-max": RANK_MAX,
                "data-slg-month-format": "text"
            },
            style: {
                display: 'block'
            },
            traits: [
                {
                    type: 'checkbox',
                    name: 'data-lg-follow-in-query',
                    label: 'Follow in query'
                }
            ].concat(MODEL.prototype.defaults.traits),
            classes: ['form-group'],
            components: [
                {
                    type: 'label',
                    attributes: {
                        for: '',
                    },
                    content: 'When is your birthday?'
                },
                {
                    type: 'input',
                    droppable: false,
                    draggable: false,
                    removable: false,
                    copyable: false,
                    attributes: {
                        type: 'date',
                        name: `birth_date`,
                        'data-slg-type': 'C-BIRTHDAY-CALENDAR',
                        min: null,
                        max: null
                    },
                    classes: ['form-control']
                }
            ]
        },
        getFormat() {
            return this.get('attributes')['data-slg-format'];
        },
        setFormat(format) {
            this.setAttributes({
                ...this.get('attributes'),
                'data-slg-format': format
            })
        },
        getRankMin() {
            return this.get('attributes')['data-slg-rank-min'];
        },
        setRankMin(rank_min) {
            this.setAttributes({
                ...this.get('attributes'),
                'data-slg-rank-min': rank_min
            })
        },
        getRankMax() {
            return this.get('attributes')['data-slg-rank-max'];
        },
        setRankMax(rank_max) {
            this.setAttributes({
                ...this.get('attributes'),
                'data-slg-rank-max': rank_max
            })
        },
        getMonthFormat() {
            return this.get('attributes')['data-slg-month-format'];
        },
        setMonthFormat(month_format) {
            this.setAttributes({
                ...this.get('attributes'),
                'data-slg-month-format': month_format
            })
        },
        controlFormat() {

            let component = this;

            let shape = component.getFormat();
            let rank_min = component.getRankMin();
            let rank_max = component.getRankMax();
            let month_format = component.getMonthFormat();
            if (!shape) {
                return
            }


            // En caso de que en el componente birth_date borren el componente de texto pasamos a buscar el primer elemento.
            // Importante.- Hay que refactorizar esta parte, es necesario buscar una manera para mantener la integridad del componente
            //                  sin depender de las posiciones.
            // let component_options = (component.components().length > 1) ? component.components().at(1) : component.components().at(0);
            let componentOptions = component.components().find((component)=>{
                let type = component.getAttributes()["data-slg-type"];
                return ['C-BIRTHDAY-SELECT', 'C-BIRTHDAY-CALENDAR'].includes(type);
            });

            let type = componentOptions.getAttributes()['data-slg-type'];

            let component_birthday;

            if (shape == FORMAT_1 && type != 'C-BIRTHDAY-SELECT') {
                let min = rank_min.split("-");
                let max = rank_max.split("-");
                /* Rank year */
                let rank_day = generateRank(1, 31);
                /* Rank Year */
                let rank_year = generateRank(min[0], max[0]);
                component_birthday = {
                    tagName: 'div',
                    classes: ['form-group', 'form-row'],
                    droppable: false,
                    attributes: {
                        // name:`answers[${question_id}]`,
                        'data-type': "birth",
                        'data-slg-type': 'C-BIRTHDAY-SELECT'
                    },
                    components: [
                        {
                            type: 'C-SELECT-DAY',
                            classes: ['col-sm-4', 'form-control'],
                            options: rank_day
                        },
                        {
                            type: 'C-SELECT-MONTH',
                            classes: ['col-sm-4', 'form-control'],
                            format: month_format
                        },
                        {
                            type: 'C-SELECT-YEAR',
                            classes: ['col-sm-4', 'form-control'],
                            options: rank_year
                        },

                    ]
                }
            } else if (shape == FORMAT_2 && type != 'C-BIRTHDAY-CALENDAR') {
                component_birthday = {
                    type: 'input',
                    classes: ['form-group'],
                    attributes: {
                        type: 'date',
                        name: `birth_date`,
                        // min: rank_min,
                        // max: rank_max,
                        'data-type': 'birth-calendar',
                        'data-slg-type': 'C-BIRTHDAY-CALENDAR'
                    },
                    classes: ['form-control']
                }
            }
            if (component_birthday)
                componentOptions.replaceWith(component_birthday);
        },

    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute('data-slg-type') == "C-BIRTHDAY")
                return { type: 'C-BIRTHDAY' }
        }
    });

    var view = VIEW.extend({

        /**
         * Trigger when the render is completed
         */
        onRender() {
            // render the button and modal
            let component = this.model;
            this.updateComponent();
            this.createCustomMenu();
        },

        updateComponent: async function () {
            let component = this.model;
            if (!component) {
                return;
            }
            // Render the question
            // await component.registerQuestion();

            // Control the current format component.
            component.controlFormat();
            // await component.registerQuestionByStep();
        },


        /**
         * @function createCustomMenu
         * @description Create a custom tooltip menu in the editor view.
         */
        createCustomMenu: function () {
            let el = this.el;
            var component = this.model;
            let tooltip = /*html*/
                `
            <div id="template">
                <ul class="list-toggle">
                    <li class="item exchange">
                        <i class="fas fa-sync"></i>
                    </li>
                    <li class="item config" data-toggle="modal" data-target="#staticBackdrop">
                        <i class="fas fa-cog fa-1x"></i>
                    </li>
                </ul>
            </div>
            `
            const instance = tippy(el, {
                content: tooltip,
                allowHTML: true,
                trigger: 'click',
                theme: 'light',
                interactive: true,
                zIndex: 100,
                arrow: true,
                onCreate(instance) {
                    /* e.preventDefault(); */
                    let itemConfig = instance.popper.querySelector('.item.config');
                    itemConfig.addEventListener('click', (e) => {
                        e.preventDefault();
                        editor.runCommand('open-modal-birthday', { component });
                        instance.hide();
                    });

                    let item_exchange = instance.popper.querySelector('.item.exchange');
                    item_exchange.addEventListener('click', (e) => {
                        e.preventDefault();
                        editor.runCommand('exchange-shape-birthday', { component });
                        instance.hide();
                    });

                },
            });
        },

    });

    DOMC.addType('C-BIRTHDAY', {
        model: model,
        view: view,
    });

    BM.add('B-BIRTHDAY', {
        label: "BIRTHDAY",
        content: {
            type: 'C-BIRTHDAY',
        },
        category: "ADVANCE COMPONENT",
        media: birthdayIcon,
    });

    COMMANDS.add('open-modal-birthday', {
        run: function (editor, sender, params) {
            let component = params.component;
            // let question_text = component.getQuestionText();
            let format = component.getFormat();
            let rank_min = component.getRankMin();
            let rank_max = component.getRankMax();
            let month_format = component.getMonthFormat();
            let name = component.get('attributes')['name'];
            let id = component.getId();

            let container = document.createElement('div');
            container.setAttribute('id', 'vue-app');

            MD.setTitle("Question birthday")
                .setContent(container)
                .open();

            new Vue({
                ...AppEditor,
                element: "ModalBirthday",
                editor,
                opts,
                payload: {
                    component,
                    // question_text,
                    format,
                    rank_min,
                    rank_max,
                    month_format,
                    attributes: {
                        name,
                        id
                    }
                }
            }).$mount('#vue-app');
        }
    });

    COMMANDS.add('update-model-birthday', {
        run: function (editor, sender, params) {
            let component = params.component;
            let question_text = params.question_text;
            let format = params.format;
            let rank_min = params.rank_min;
            let rank_max = params.rank_max;
            let month_format = params.month_format;
            let id = params.id;
            let name = params.name;
            component.set({
                attributes: {
                    ...component.get('attributes'),
                    name,
                    id
                }
            });
            component.setFormat(format);
            component.setRankMin(rank_min);
            component.setRankMax(rank_max);
            component.setMonthFormat(month_format);
            component.setComponentQuestionTextContent(question_text);
            component.view.updateComponent();

        }
    });

    COMMANDS.add('exchange-shape-birthday', {
        run: function (editor, sender, params) {
            let component = params.component;
            let format = component.getFormat();

            if (format == FORMAT_1) {
                component.setFormat(FORMAT_2);
            } else {
                component.setFormat(FORMAT_1);
            }
            component.view.updateComponent();

        }

    });



};
